import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue";
import BoardHistoryRowInfo from "@/components/board/BoardHistoryRowInfo.vue";
import { IBoardInfo } from "@/domain/entities/board";
import router from "@/router";
import { RouterName } from "@/types";


const __default__ = {
  name: "BoardHistoryRow",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  boardInfo: {
    type: Object as PropType<IBoardInfo>,
    required: true,
  },
},
  emits: ["onClickBoardHistoryRow"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const emitOnClickBoardHistoryRow = () => {
  if (!props.boardInfo.isEvaluable) return;

  emit("onClickBoardHistoryRow", props.boardInfo);
};

const goToBoardEvaluation = (boardInfo: IBoardInfo) => {
  const { lineTurnUid, allocUid, lineTypeCode, lineRouteName, campusName } =
    boardInfo;

  router.push({
    name: RouterName.BoardEvaluation,
    query: {
      lineTurnUid,
      allocUid,
      lineTypeCode,
      lineName: lineRouteName,
      campusName,
    },
  });
};

const __returned__ = { props, emit, emitOnClickBoardHistoryRow, goToBoardEvaluation, BoardHistoryRowInfo }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})